import $ from 'jquery';

export default class Goal {
  constructor(element) {
    this.$el = $(element.el);
    this.$document = $(document.body);
    this.$selector = $('[data-goal-countdown]');
    this.endDateTime = this.$selector.data('end-time');

    // TODO: Do better checking or parsing on passed value to make sure its a proper date
    if (this.$selector.length && (this.getRemainingTime().total >= 0)) {
      this.countDownTimer();
    }
    $('body').addClass('has-goal-expired');
  }

  getRemainingTime() {
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    const t = Date.parse(this.endDateTime) - Date.parse(new Date());
    const seconds = Math.floor((t / _second) % 60);
    const minutes = Math.floor((t / _minute) % 60);
    const hours = Math.floor((t / _hour) % 24);
    const days = Math.floor(t / _day);

    return {
      total: t, days, hours, minutes, seconds,
    };
  }

  countDownTimer() {
    this.$countdownDays = this.$selector.find('[data-goal-countdown-days]');
    this.$countdownHours = this.$selector.find('[data-goal-countdown-hours]');
    this.$countdownMinutes = this.$selector.find('[data-goal-countdown-minutes]');
    this.$countdownSeconds = this.$selector.find('[data-goal-countdown-seconds]');
    this.lastDayText = this.$selector.data('alt-text');

    this.$productViewDays = $('.product-goal-info-days');
    this.$productViewDaysWrapper = $('.product-goal-info-remaining');

    this.runTimer();
    this.timer = setInterval(() => this.runTimer(),
      1000);

    setTimeout(() => {
      this.$el.addClass('active');
      this.$document.trigger('checkHeaderOffsets');
    },
    100);
  }

  runTimer() {
    const timeRemaining = this.getRemainingTime();

    if (timeRemaining.total <= 0) {
      this.$('.module-header-goal-time-up').removeClass('hidden');
      this.$selector.addClass('hidden');
      clearInterval(this.timer);
      return;
    }
    this.$countdownDays.html(timeRemaining.days);
    this.$countdownHours.html(timeRemaining.hours);
    this.$countdownMinutes.html(timeRemaining.minutes);
    this.$countdownSeconds.html(timeRemaining.seconds);


    if (this.$productViewDays.length) {
      if ((timeRemaining.total > 0) && (timeRemaining.days === 0)) {
        this.$productViewDaysWrapper.html(this.lastDayText);
      }
      this.$productViewDays.html(timeRemaining.days);
    }
  }
}
